import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WholesaleVoiceTermination from "../pages/solutions/WholesaleVoiceTermination";
import VoipOperators from "../pages/solutions/VoipOperators";
import Resellers from "../pages/solutions/Resellers";
import CallCentersCpaas from "../pages/solutions/CallCentersCpaas";
import AntiFraud from "../pages/solutions/AntiFraud";
import CoverageRates from "../pages/coverage/page";
import NetworkQuality from "../pages/network/page";
import WhyVoxmaster from "../pages/why-voxmaster/page";
import Company from "../pages/company/page";
import Contact from "../pages/contact/page";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import TermsOfService from "../pages/legal/TermsOfService";
import Msa from "../pages/legal/Msa";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/solutions/wholesale-voice-termination",
    element: <WholesaleVoiceTermination />,
  },
  {
    path: "/solutions/voip-operators",
    element: <VoipOperators />,
  },
  {
    path: "/solutions/resellers",
    element: <Resellers />,
  },
  {
    path: "/solutions/call-centers-cpaas",
    element: <CallCentersCpaas />,
  },
  {
    path: "/solutions/anti-fraud",
    element: <AntiFraud />,
  },
  {
    path: "/coverage",
    element: <CoverageRates />,
  },
  {
    path: "/network",
    element: <NetworkQuality />,
  },
  {
    path: "/why-voxmaster",
    element: <WhyVoxmaster />,
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/legal/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/legal/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/legal/msa",
    element: <Msa />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;